export const ZEROES = "0000000000000000000000000000000000000000000000000000000000000000";
//# sourceMappingURL=general.js.map